import FileSaver from 'file-saver';

export function debounce(func, timeout = 2000) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export const POSTCODE_VALIDATION_UTIL = {
  14: (item) => item.trim().length !== 4 || isNaN(item.trim()),
};

export const downloadFile = (data, filename) => {
  try {
    const fileBlob = new Blob([data], { type: 'application/zip' });
    FileSaver.saveAs(fileBlob, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
};
const regexQuery =
  '^(https?:\\/\\/)?((([-a-z0-9]{1,63}\\.)*?[a-z0-9]([-a-z0-9]{0,253}[a-z0-9])?\\.[a-z]{2,63})|((\\d{1,3}\\.){3}\\d{1,3}))(:\\d{1,5})?((\\/|\\?)((%[0-9a-f]{2})|[-\\w\\+\\.\\?\\/@~#&=])*)?$';
const url = new RegExp(regexQuery, 'i');
export function isValidUrl(string) {
  try {
    return url.test(string);
  } catch (err) {
    return false;
  }
}
